import { isEmpty } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { BriefSection, SectionTypes } from '../types';

export const SUPPORTED_LANGUAGES = ['en-US'];

// Optional context argument to allow server side usage with RequestContext package
export const isAiBriefAvailable = (locale?: string) => {
    const _locale = locale || getContext().locale;
    const isUserLanguageSupported = SUPPORTED_LANGUAGES.includes(_locale);

    return isUserLanguageSupported;
};

export const isSectionEmpty = <TContent = string>(section: BriefSection<TContent>) =>
    section.type !== SectionTypes.view &&
    (section.customValidator ? !section.customValidator(section) : isEmpty(section?.content));

export const isMandatoryAndEmpty = (section: BriefSection) => section.mandatory && isSectionEmpty(section);
